





















































































import { defineComponent, reactive, SetupContext, computed, toRef, toRefs, watch, onMounted } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, SheetField, ImageItem } from "../../modules/teacher/FieldEdit"


export interface Data {
  sheet_id: string
  sheet: Sheet
  sheetFields: SheetField[]
  currentPage: number
  imageItems: ImageItem[]
  scale: number,
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: new Sheet({}),
      sheetFields: new Array<SheetField>(),
      currentPage: 1,
      imageItems: new Array<ImageItem>(),
      scale: 0.5,
      errors: [],
    });

    /******************************
     * computed
     ******************************/

    // 表示用の問題構造一覧
    const questionSheetFields = computed((): SheetField[] => {
      return state.sheetFields.filter(x => x.kind == 0 && x.page == state.currentPage);
    });

    // 表示中の模範解答画像
    const currentImageItem = computed((): ImageItem => {
      return state.imageItems.filter(x => x.pageNo == state.currentPage)[0];
    });

    /**
     * imgタグのスタイル
     */
    const imageStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      style["width"] = `${currentImageItem.value.baseWidth * state.scale}px`;
      style["height"] = `${currentImageItem.value.baseHeight * state.scale}px`;
      style["transform"] = `rotate(${currentImageItem.value.angle}deg)`;

      // 回転の中心軸設定
      let translateX: string = "";
      let translateY: string = "";
      if(currentImageItem.value.angle == 90){
        translateX = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
      }else if(currentImageItem.value.angle == 180){
        translateX = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
      }else if(currentImageItem.value.angle == 270){
        translateX = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
      }
      return style;
    });

    /**
     * imgの親divのスタイル
     */
    const imageWrapStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      if(currentImageItem.value.angle == 0 || currentImageItem.value.angle == 180){
        style["height"] = `${(currentImageItem.value.baseHeight * state.scale) + 30}px`;
      }else{
        style["height"] = `${(currentImageItem.value.baseWidth * state.scale) + 30}px`;
      }
      return style;
    });

    /******************************
     * methods
     ******************************/

    const downloadFieldTemplate = async (): Promise<void> => {
      window.location.href = `/api/field_edit/download_field_template/${state.sheet_id}`;
    }

    /**
     * 問題構造アップロード処理
     */
    const uploadSheetField = async (file: File): Promise<void> => {

      const formData = new FormData();
      formData.append(`upload[file]`, file);

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/field_edit/upload_sheet_field/${state.sheet_id}`, formData).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.sheetFields = response.data.sheet.sheet_fields.map((x: any) => new SheetField(x));

        alert(`アップロードが完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /**
     * 模範解答アップロード処理
     */
    const uploadedCorrectImage = async (file: File): Promise<void> => {

      const formData = new FormData();
      formData.append(`upload[file]`, file);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/field_edit/upload_correct_image/${state.sheet_id}`, formData).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.imageItems = response.data.base64_images.map((x: any) => new ImageItem(x));
        alert(`アップロードが完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /**
     * 保存ボタンクリック
     */
    const saveClick = async (): Promise<void> => {

      if(!window.confirm("問題構造を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.patch(`/api/field_edit/${state.sheet_id}`, {sheet_fields: state.sheetFields.filter(x => x.kind == 0)}).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.sheetFields = response.data.sheet.sheet_fields.map((x: any) => new SheetField(x));
        
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/field_edit?sheet_id=${state.sheet_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.sheetFields = response.data.sheet.sheet_fields.map((x: any) => new SheetField(x));
        state.imageItems = response.data.base64_images.map((x: any) => new ImageItem(x));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch('goSheetList');
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      questionSheetFields,
      currentImageItem,
      imageStyle,
      imageWrapStyle,
      downloadFieldTemplate,
      uploadSheetField,
      uploadedCorrectImage,
      saveClick,
    };
  },
})
